/** Replaces <highlighted_text> tags in report HTML with a styled span for dangerouslySetInnerHTML rendering. */
export var processReport = function processReport(raw) {
  return raw.replace(/<highlighted_text>([^]*?)<\/highlighted_text>/g, function (_, p1) {
    return "<span class=\"text-sds-attention-default font-semibold\">".concat(p1, "</span>");
  });
};